module.exports = __webpack_public_path__ + "img/logotb.e22eb477.png";